import { defineStore } from "pinia";
import { ref } from "vue";

export const useFiltersStore = defineStore("filters", () => {
  const selectedSlug = ref("all");
  const selectedDescription = ref("");
  function setFilter(slug: string, description?: string) {
    selectedSlug.value = slug;
    selectedDescription.value = description ? description : "";
  }

  return { selectedSlug, selectedDescription, setFilter };
});
